export default {
  computed: {
    configs() {
      const M_PROPINSI = this.masters.propinsi || {};
      const M_KOTA = this.masters.kota || {};
      return {
        asal: {
          selector: ['k_propinsi', 'k_kota'],
          required: ['k_propinsi', 'k_kota'],
          label: ['Provinsi (tempat tinggal)', 'Kabupaten/Kota (tempat tinggal)'],
          options: [M_PROPINSI, M_KOTA],
          grid: [{ cols: 6 }, { cols: 6 }],
        },
        ktp: {
          selector: ['k_propinsi_ktp', 'k_kota_ktp'],
          required: ['k_propinsi_ktp', 'k_kota_ktp'],
          label: ['Provinsi (sesuai KTP)', 'Kota/Kabupaten (sesuai KTP)'],
          options: [M_PROPINSI, M_KOTA],
          grid: [{ cols: 6 }, { cols: 6 }],
        },
      };
    },

    ptk() {
      return this.$getDeepObj(this.initValue, 'ptk') || {};
    },

    dasar() {
      return [
        {
          type: 'textView',
          label: `Nama`,
          value: this.$getDeepObj(this.initValue, 'ptk.nama') || '',
          grid: { cols: 12 },
        },
        {
          type: 'textView',
          label: `NIK`,
          value: this.$getDeepObj(this.initValue, 'psp_profil.nik') || '',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Nomor SIMPKB`,
          value: this.$getDeepObj(this.initValue, 'ptk_id') || '',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Tempat Lahir`,
          value: this.$getDeepObj(this.initValue, 'ptk.tmp_lahir') || '',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Tanggal Lahir`,
          value: this.$localDate(this.$getDeepObj(this.initValue, 'ptk.tgl_lahir')) || '',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Usia`,
          value: this.ptk.tgl_lahir ? `${this.$getAge(this.ptk.tgl_lahir)}` : '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'VTextarea',
          name: 'alamat_ktp',
          label: 'Alamat (sesuai KTP)',
          hint: 'wajib diisi',
          required: true,
          grid: { cols: 12 },
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'cascade',
          labelColor: 'info',
          configs: this.configs && this.configs['ktp'],
          grid: { cols: 12 },
        },
        {
          type: 'VTextarea',
          name: 'alamat',
          label: 'Alamat (tempat tinggal sekarang)',
          hint: 'wajib diisi',
          required: true,
          grid: { cols: 12 },
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'cascade',
          labelColor: 'info',
          configs: this.configs && this.configs['asal'],
          grid: { cols: 12 },
        },
        {
          type: 'VTextField',
          name: 'kodepos',
          label: 'Kode Pos',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          mask: '#####',
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
      ];
    },

    kontak() {
      return [
        {
          type: 'VTextField',
          name: 'no_hp',
          label: 'Nomor Telepon (HP)',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          mask: '###############',
          outlined: true,
          dense: true,
          singleLine: true,
          required: true,
        },
        {
          type: 'VTextField',
          name: 'no_wa',
          label: 'Nomor Telepon (terhubung WhatsApp)',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          mask: '###############',
          outlined: true,
          dense: true,
          singleLine: true,
          required: true,
        },
        {
          type: 'VTextField',
          name: 'no_hp_prabayar',
          label: 'No HP prabayar (aktif)',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          mask: '###############',
          outlined: true,
          dense: true,
          singleLine: true,
          required: true,
        },
        {
          type: 'VTextField',
          name: 'nama_prabayar',
          label: 'Nama pemilik No HP Prabayar (aktif)',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
          required: true,
        },
        {
          type: 'VTextField',
          name: 'email',
          label: 'Alamat Surel',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
          required: true,
        },
        {
          type: 'textView',
          label: `Akun belajar.id yang dimiliki / dari sekolah`,
          value: this.$getDeepObj(this.initValue, 'akun_belajar') || '',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'VTextField',
          name: 'akun_belajar_upt',
          label: 'Akun belajar.id yang diberikan oleh Direktorat sebagai FSP/PA',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
          required: true,
        },
      ];
    },

    pendidikan() {
      return [
        {
          type: 'VSelect',
          name: 'k_kualifikasi',
          label: 'Pendidikan terakhir',
          hint: 'wajib diisi',
          items: this.$mapForMaster(this.masters['kualifikasi']),
          itemText: 'text',
          itemValue: 'value',
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'VTextField',
          name: 'pendidikan_jurusan',
          label: 'Jurusan',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VSelect',
          name: 'k_pendidikan_bidang_psp',
          label: 'Bidang Pendidikan Terakhir',
          hint: 'wajib diisi',
          items: this.$mapForMaster(this.masters['pendidikan_bidang'], 'k_profil_opsi_psp'),
          itemText: 'text',
          itemValue: 'value',
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'VTextField',
          name: 'pendidikan_instansi',
          label: 'Nama instansi pendidikan terakhir',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
      ];
    },

    penugasan() {
      return [
        {
          type: 'VSelect',
          name: 'k_pendampingan_psp',
          label: 'Pengalaman melakukan pendampingan peningkatan mutu pendidikan',
          hint: 'wajib diisi',
          items: this.$mapForMaster(this.masters['pendampingan'], 'k_profil_opsi_psp'),
          itemText: 'text',
          itemValue: 'value',
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'VSelect',
          name: 'k_unsur_psp',
          label: 'Unsur Fasilitator',
          hint: 'wajib diisi',
          items: this.$mapForMaster(this.masters['unsur_psp']),
          itemText: 'text',
          itemValue: 'value',
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'VTextField',
          name: 'profesi',
          label: 'Apa profesi/pekerjaan Anda saat ini',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
      ];
    },
  },
};
